<div class="p-5 listaTarjetas">
    <h3 class="titulo" *ngIf="!cargando">Seleccionar tarjeta</h3>
    <br>
    <div class="cargando" *ngIf="cargando">
        <div class="w-100 d-flex justify-content-center p-3">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </div>
    </div>

    <div class="tarjetas mt-2">
        <div *ngIf="!cargando">
            <!-- Lista de tarjetas -->
            <div class="row" *ngIf=" listaTarjetas.length > 0">
                <div class="col-12">



                    <div class="form-check mb-2" *ngFor="let tarjeta of listaTarjetas"
                        [ngClass]="{ selected: tarjeta.selected }">
                        <label class="form-check-label d-flex justify-content-between">
                            <div (click)="seleccionarTarjeta(tarjeta.paymentProfileId)">
                                <i class="far fa-credit-card"></i>
                                <!-- <span class="brand mx-4"> {{ tarjeta.paymentProfileId }}</span> -->
                                <span class="brand mx-4"> {{ tarjeta.brand }}</span>
                                <span class="last4 d-flex align-items-center">
                                    <i class="fas fa-asterisk"></i>
                                    <i class="fas fa-asterisk"></i>
                                    <i class="fas fa-asterisk"></i>
                                    <i class="fas fa-asterisk mr-2"></i>
                                    {{ tarjeta.last4 }}</span>
                            </div>
                            <a class="d-flex flex-column justify-content-center mr-4"
                                *ngIf="!tarjeta.isDefaultSuscription"
                                (click)="eliminarTarjeta(tarjeta.paymentProfileId)">
                                <i class="far fa-trash-alt"></i>
                            </a>
                        </label>
                    </div>



                    <!-- <div class="item mb-2" *ngFor="let tarjeta of listaTarjetas"
                        [ngClass]="{ selected: tarjeta.selected }"
                        (click)="seleccionarTarjeta(tarjeta.paymentProfileId)">

                        <div class="d-flex justify-content-between">
                            <div class="d-flex">
                                <div class="custom-control custom-checkbox mr-2">
                                    <input type="checkbox" class="custom-control-input"
                                        id="customCheck-{{tarjeta.paymentProfileId}}" [checked]="tarjeta.selected">
                                    <label class="custom-control-label"
                                        for="customCheck-{{tarjeta.paymentProfileId}}"></label>
                                </div>

                                <span class="brand mr-4"> {{ tarjeta.brand }}</span>
                                <span class="last4 d-flex align-items-center">
                                    <i class="fas fa-asterisk"></i>
                                    <i class="fas fa-asterisk"></i>
                                    <i class="fas fa-asterisk"></i>
                                    <i class="fas fa-asterisk mr-2"></i>
                                    {{ tarjeta.last4 }}</span>
                            </div>
                            <a class="d-flex flex-column justify-content-center " *ngIf="!tarjeta.isDefaultSuscription"
                                (click)="eliminarTarjeta(tarjeta.paymentProfileId)">
                                <i class="far fa-trash-alt"></i>
                            </a>
                        </div>
                    </div> -->

                </div>


            </div>


            <!-- IframeCustom -->
            <div class="row" *ngIf="uniqueID">
                <div class="col-12 mb-2 py-2">
                    <button class="btn btn-primary btn-block text-left p-3 px-4" (click)="agregarTarjeta()">
                        <i class="fas fa-plus"></i>
                        <strong class="last4 ml-4">Agregar nueva tarjeta</strong>
                    </button>
                </div>

                <!-- <div class="col-12 col-lg-5 mb-2 py-2">
            <button class="btn btn-dark btn-block text-left p-3 px-4" (click)="ingresarTarjeta()">
              <i class="fas fa-credit-card"></i>
              <strong class="last4 ml-4">Ingresar tarjeta</strong>
            </button>
          </div> -->
            </div>

            <!-- IframeNoraml -->
            <div class="row" *ngIf="!uniqueID">
                <div class="col-12">
                    <button class="btn btn-primary btn-block p-3 px-4 text-left py-2" (click)="ingresarTarjeta()">
                        <i class="fas fa-credit-card"></i>
                        <strong class="last4 ml-4">Ingresar tarjeta</strong>
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-12 pt-4 justify-content-center d-flex">
                    <button class="btn pink btn-guardar my-4 " (click)="guardar()">
                        <span *ngIf=" cargando" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                        <span *ngIf="!cargando">

                            <span> <i class="fas fa-save mr-2"></i> GUARDAR</span>
                        </span>
                    </button>

                </div>
            </div>
        </div>


    </div>
</div>

<input type="hidden" name="PWToken" id="PWToken" />